import { format } from 'date-fns'
import { z } from 'zod'
import { isValidCPFOrCNPJ } from '../utils/formatDocuments'

z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type' && issue.received === 'undefined') {
    return { message: 'Este campo é obrigatório' }
  }

  return { message: ctx.defaultError }
})

export const employeeSchema = z.object({
  id: z.number().optional(),

  nome: z
    .string()
    .min(3, 'O nome deve ter no mínimo 3 caracteres')
    .refine((value) => value.trim() !== '', 'O nome não pode ser vazio'),
  cpf: z
    .string()
    .min(1, 'O documento é obrigatório')
    .refine((value) => isValidCPFOrCNPJ(value), 'CPF ou CNPJ inválido'),

  dataNascimento: z
    .string()
    .regex(/^\d{2}\/\d{2}\/\d{4}$/, 'Data de nascimento é obrigatória')
    .refine((value) => {
      const [day, month, year] = value.split('/').map(Number)
      const date = new Date(year, month - 1, day)
      return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
    }, 'Data inválida')
    .transform((value) => {
      const [day, month, year] = value.split('/').map(Number)
      const date = new Date(year, month - 1, day)
      return format(date, "yyyy-MM-dd'T'HH:mm:ss")
    }),

  rg: z.string({ required_error: 'RG é obrigatório' }).refine((value) => value.trim() !== '', 'O RG não pode ser vazio'),

  // address: z.string().min(1, 'Endereço completo é obrigatório'),
  ctps: z
    .string()
    .min(1, 'CTPS é obrigatório')
    .refine((value) => value.trim() !== '', 'CTS não pode ser vazio'),

  contato: z.object({
    telefone: z.string().refine((value) => value.trim() !== '', 'O telefone não pode ser vazio'),
    email: z
      .string()
      .email('Email inválido')
      .refine((value) => value.trim() !== '', 'O email não pode ser vazio')
  }),

  dataAdmissao: z
    .string()
    .min(1, 'Data de admissão é obrigatória')
    .regex(/^\d{2}\/\d{2}\/\d{4}$/, 'Data no formato inválido')
    .refine((value) => {
      const [day, month, year] = value.split('/').map(Number)
      const date = new Date(year, month - 1, day)
      return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
    }, 'Data inválida')
    .transform((value) => {
      const [day, month, year] = value.split('/').map(Number)
      const date = new Date(year, month - 1, day)
      return format(date, "yyyy-MM-dd'T'HH:mm:ss")
    }),

  // resignationDate: z.string().optional(),
  //isEmployee: z.boolean().default(true),
  cargo: z
    .string()
    .min(1, 'Cargo é obrigatório')
    .refine((value) => value.trim() !== '', 'Cargo não pode ser vazio'),

  // salario: z.number().positive('Salário deve ser positivo'),
  salario: z
    .string()
    .min(1, 'Salário obrigatório')
    .refine((value) => value.trim() !== '', 'Salário não pode ser vazio'),

  tipoContrato: z
    .string()
    .min(1, 'Contrato deve ser obrigatório')
    .refine((value) => value.trim() !== '', 'Contrato não pode ser vazio'),

  regimeTrabalho: z
    .string()
    .min(1, 'Contrato deve ser obrigatório')
    .refine((value) => value.trim() !== '', 'Contrato não pode ser vazio'),

  nomeEmergencia: z.string().optional(),

  telefoneEmergencia: z.string().optional(),

  unidade: z.object({
    id: z.union([z.number().int(), z.string()])
  }),
  idUsuario: z.string().min(1, 'Usuário é obrigatório'),
  inclusao: z.string().optional()
})

export type EmployeeFormData = z.infer<typeof employeeSchema>

interface Contato {
  telefone: string
  email: string
}

export interface EmployeeData {
  id?: number
  nome: string
  cpf: string
  dataNascimento: string // YYYY-MM-DD HH:mm:ss.SSSSSS
  rg: string
  ctps: string
  dataAdmissao: string // YYYY-MM-DD HH:mm:ss.SSSSSS
  cargo: string
  salario: string
  tipoContrato: string
  contato: Contato
  nomeEmergencia: string
  telefoneEmergencia: string
  unidade: {
    id: number
  }
}
